<form [formGroup]="distributionListForm">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'notification.addEmail' | translate }}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
      tabindex="0"
      (keydown.enter)="close()"
    ></button>
  </div>
  <div class="modal-body">
    <span>{{ 'notification.emailMessage' | translate }}</span>
    <div class="input-container">
      <textarea
        name="distributionEmails"
        formControlName="inputEmail"
        id="distributionEmails"
        cols="30"
        rows="4"
        (input)="emailAddress()"
      ></textarea>
      <span class="error-text">{{ distributionListFormErrors.inputEmail }}</span>
    </div>
  </div>

  <div class="modal-footer">
    <button
      role="button"
      class="button button-clear"
      aria-label="Close"
      (click)="close()"
      tabindex="0"
      (keydown.enter)="close()"
    >
      {{ 'common.cancel' | translate }}
    </button>
    <button
      role="button"
      class="button button-pink"
      (click)="addEmailAddress()"
      [disabled]="errorFlag"
      [ngStyle]="{ 'pointer-events': isLoader() ? 'none' : '' }"
      tabindex="0"
      (keydown.enter)="addEmailAddress()"
    >
      <span>
        @if (isLoader()) {
          <span class="spinner-border spinner-border-sm"></span>
        }
        <span class="m-3">{{ 'common.save' | translate }}</span>
      </span>
    </button>
  </div>
</form>
